import HttpProvider from '@src/api/httpProvider';
import { BaseResponse } from '@src/api/model';

export default class Services {
    static getCharge = async (payload) => {
        const res = await HttpProvider.post('charge', payload);

        return new BaseResponse(res);
    };
    static appDownloadRecord = async ({
        // 裝置類型 1:ios 2:android
        deviceType,
        // 測速選擇域名
        domain = '',
    }) => {
        const res = await HttpProvider.post('common/appDownloadRecord', {
            deviceType,
            domain,
        });

        return new BaseResponse(res);
    };

    static chargeFinished = async (apiOrderId) => {
        const res = await HttpProvider.get(`charge/finished/${apiOrderId}`);

        return new BaseResponse(res);
    }
}
